<template>
	<v-sheet flat>
		<render-content id="fulldata"> </render-content>

		<loading v-if="loading"></loading>
		<div v-else>
			<v-sheet>
				<v-data-table :headers="headers" :items="items" item-key="uid"></v-data-table>
				<export :columns="headers" :rows="items" name="dma-data" text="Export full dataset"></export>
			</v-sheet>
		</div>
	</v-sheet>
</template>

<style lang="less"></style>

<script>
import Export from "@c/downloads/Export";
import Loading from "@c/ui/Loading";
import RenderContent from '@c/ui/RenderContent.vue';
export default {
	name: "Data",
	components: {
		Loading,
		RenderContent,
		Export,
	},
	data: () => {
		return {
			loading: true,
		};
	},
	computed: {
		categoryOptions() {
			return this.$store.state.categoryOptions.data;
		},
		order() {
			return this.$store.getters.order;
		},
		responses() {
			return this.$store.state.sectionResponses.data;
		},
		sections() {
			return this.$store.state.sections.data;
		},
		headers() {
			return [
				{ text: "Section", value: "section" },
				{ text: "Theme", value: "theme" },
				{ text: "Question", value: "question" },
				{ text: "Service", value: "service" },
				{ text: "Answer", value: "processed_answer" },
				{ text: "Score", value: "score" },
			];
		},
		results() {
			const self = this;
			return this.order
				.filter((item) => self.responses[item.response])
				.flatMap((item) => {
					let response = self.responses[item.response];
					return this.mwsurveyutils.processResponse(response);
				})
				.filter((exists) => exists);
		},
		items() {
			const self = this;
			return self.results.map((response) => {
				let r = { ...response };
				r.uid = `${r.section}-${r.response}-${r.question}`;
				let section = self.sections[r.section];
				let theme = self.categoryOptions[section.theme];
				let category = self.categoryOptions[r["service"]];
				let questionText = self.$store.getters["questions/getQuestionTexts"](r.question);
				r.section = section ? section.name : "";
				r.theme = theme ? theme.name : "";
				r.question = questionText ? questionText.string : "";
				r.service = category ? category.name : "";
				return r;
			});
		},
	},
	watch: {
		responses: {
			immediate: true,
			handler() {
				if (this.responses && Object.keys(this.responses).length) {
					this.loading = false;
				}
			},
		},
	},
};
</script>
